export default __webpack_public_path__ + "static/media/security.67f411f3.svg";